
import {
  Row,
  Col,
  Button,
  ButtonGroup,
}from 'react-bootstrap';

import {
  Label,
  Audio,
  ListView,
}from '../';

import { COLOR } from '../../const';

var React = require('react');
var Radium = require('radium');
var FontAwesome = require('react-fontawesome');
var HelperScripts = require('../../utils/HelperScripts.js');

class IdentifyAct extends React.Component {
  render() {
    return(
      <div>
        <Row>
          <ListView {...this.props}>
            {this.props.progressList.map(item => (
              <IdentItem
                key={item.word}
                item={item}
                isCorrect = {item.isCorrect}
                wasChecked = {item.wasChecked}
                {...this.props}
              />
            ))}
          </ListView>
        </Row>
      </div>
    )
  }
}

class IdentItem extends React.Component {

  constructor(props){
    super(props);

    this.state = {
      options: [],
    };
  }

  playAudio = () => {
    this.audio.onPlay();
  }

  componentDidMount(){
    //console.log(this.state.options.length);

    if (this.state.options.length === 0) {
      this.setOptions();
    }

  }

  setOptions = () => {
    const {item, progressList} = this.props;

    //If no word, stop
    if (!item) return;

    //Options array
    let options = [{}];

    options[0] = {
      word: item.word,
      isCorrect:true,
    };

    //Get options
    for(var i = 0, len = 3; i < len ; i++){
      //Random position in the list
      let index = Math.floor(Math.random() * progressList.length);
      //console.log("INDEX =" + index);
      let newWord = progressList[index].word;
      if (options.filter(e => (e.word === newWord)).length === 0){
        //Next index of array
        options[options.length] = {
          word: newWord,
          isCorrect:false,
        };
      }else{
        i--;
      }
    }
    //console.log(options);
    //Assign the right one at the end

    //Shuffle
    options = HelperScripts.ShuffleArray(options);
    //Error handling
    if (!options) {
      console.log(`ERROR: Options for item with word ${item.word} are empty!`);
      return;
    }
    //Assign
    this.setState({
      options: options,
    });
  }

  handleAnswerClick = (text) => {
    const {item} = this.props;

    if (this.props.wasChecked) return;

    if (text === item.word && !this.props.wasChecked){
      //Right answer
      this.props.updateProgressList({
        word: this.props.item.word,
        isCorrect: true,
        wasChecked: true,
      })
    }else{
      //Wrong answer
      this.props.updateProgressList({
        word: this.props.item.word,
        isCorrect: false,
        wasChecked: true,
      })
    }
  }

  render() {

    const {container, header, sentence, footer, button, check} = styles.item.base;
    const {container: containerCorr , sentence: sentenceCorr} = styles.item.correct;
    const {container: containerNorm , sentence: sentenceNorm} = styles.item.notChecked;
    const {container: containerIncorr , sentence: senteceIncorr} = styles.item.incorrect;

    const {item, mode, toggleAudio, setAudioFalse, isAudioPlaying, updateProgressList, isCorrect, wasChecked} = this.props;

    return (
      <Col
        xs={12}
        md={4}
        style={
          styles.item.base
        }
      >
        <div style={[
          container,
          !isCorrect && !wasChecked && containerNorm,
          !isCorrect && wasChecked && containerIncorr,
          isCorrect && wasChecked && containerCorr,
        ]}>
          <div style={header}>
            <Label color="white" italic text={"Possible Answers:"}/>
          </div>
          <AnswerList
            options = {this.state.options}
            handleAnswerClick = {this.handleAnswerClick}
            isCorrect={isCorrect}
            wasChecked={wasChecked}
          />
          <div style={footer}>
            <Button
              bsStyle={"success"}
              bsSize="lg"
              onClick={this.playAudio}
              style={button}
               >
              <FontAwesome
                name="volume-up"
                inverse={true}
                size="lg"
              />
            </Button>
          </div>
          <Audio
            mode={mode}
            item={item}
            isAudioPlaying={isAudioPlaying}
            toggleAudio={toggleAudio}
            setAudioFalse={setAudioFalse}
            ref={(Audio) => {this.audio = Audio;}}
          />
        </div>
      </Col>
      )
  }
}

let AnswerList = ({options = [], handleAnswerClick, wasChecked}) => (
  <ButtonGroup vertical block>
    {options.map(option => {

      let bsStyle, textStyle, buttonStyle;

      //Correct and checked
      if (option.isCorrect && wasChecked){
        textStyle = {...styles.item.correct.option};
        buttonStyle = {...styles.item.correct.optionBtn};
        bsStyle="success";
      //Incorrect and checked
      }else if (!option.isCorrect && wasChecked){
        textStyle = {...styles.item.incorrect.option};
        buttonStyle = {...styles.item.incorrect.optionBtn};
        bsStyle="danger";
      //Not checked
      }else{
        textStyle = {...styles.item.base.option};
        buttonStyle = {...styles.item.base.optionBtn};
        bsStyle="primary";
      }



      return(
        <Button
          key={option.word}
          bsStyle={bsStyle}
          style={buttonStyle}
          bsSize="lg"
          onClick={() => handleAnswerClick(option.word)}
        >
          <div style={textStyle}>
            {option.word}
          </div>
        </Button>
        )
      })}
  </ButtonGroup>
)

/* RADIUM WRAPPER */
IdentItem = Radium(IdentItem);
/* ------------- */

const styles = {
  item: {
    base:{
      textAlign: 'center',
      marginBottom: '4rem',

      container: {
        borderRadius: '10px',
        minHeight: window.innerHeight * 0.3,
      },
      header: {
        padding: '2rem',
      },
      footer: {
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        padding: '2rem',
      },
      button:{
        minWidth: '200px',
        marginTop: 'auto',
      },
      check: {
        minWidth: '200px',
      },
      option: {
        color: COLOR.blue,
      },
      optionBtn: {
        backgroundColor: COLOR.white,
      },
    },
    notChecked: {
      container: {
        borderColor: COLOR.blue,
        backgroundColor: COLOR.blue,
      },
    },
    correct: {
      container: {
        borderColor: COLOR.green,
        backgroundColor: COLOR.green,
      },
      option: {
        color: COLOR.white,
      },
      optionBtn: {
        backgroundColor: COLOR.green,
      },
    },
    incorrect: {
      container: {
        borderColor: COLOR.red,
        backgroundColor: COLOR.red,
      },
      option: {
        color: COLOR.red,
      },
      optionBtn: {
        backgroundColor: COLOR.white,
      },
    }
  },

}

export default Radium(IdentifyAct);



// WEBPACK FOOTER //
// ./src/comp/Activities/IdentifyAct.js